import React, { useEffect, useRef, useState } from 'react';

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Unstable_Grid2';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Variant } from '@mui/material/styles/createTypography';
import styles from '../styles/CourseDialog.module.scss';

interface TooltipComponentProps {
  label: string;
  variant: Variant;
}
export const TooltipComponent = (props: TooltipComponentProps) => {
  const [open, setOpen] = useState(false);
  const [clamped, setClamped] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (contentRef && contentRef.current) {
        setClamped(
          contentRef.current.scrollHeight > contentRef.current.clientHeight
        );
      }
    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [props.label]);

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  return (
    <Grid container wrap="nowrap">
      <Grid className={styles.courseInfoTrimText} ref={contentRef}>
        <Tooltip title={props.label || ''} placement="bottom-start">
          <Typography variant={props.variant}>{props.label}</Typography>
        </Tooltip>
      </Grid>
      {clamped && (
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          className={styles.seemore}
          style={{ width: '100%' }}
        >
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
              PopperProps={{ disablePortal: true }}
              onClose={handleTooltipClose}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={props.label}
            >
              <Typography
                variant="caption"
                className={styles.textUnderline}
                onClick={handleTooltipOpen}
              >
                See more
              </Typography>
            </Tooltip>
          </ClickAwayListener>
        </Grid>
      )}
    </Grid>
  );
};
